"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnouncementServiceLive = void 0;
const HttpProvider_1 = require("../utils/HttpProvider");
class AnnouncementServiceLive {
    getCompanyAnnouncements(companyId, page, rowsPerPage, sortOrder, sortBy) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/announcements?page=${page}&rowsPerPage=${rowsPerPage}&sortOrder=${sortOrder}&sortBy=${sortBy}`);
            return response.data;
        });
    }
    getAnnouncement(companyId, announcementId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/company/${companyId}/announcements/${announcementId}`);
            return response.data;
        });
    }
    getAttachmentSignedUrl(companyId, announcementId, filename) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/company/${companyId}/announcements/${announcementId}?filename=${filename}`;
            const response = yield HttpProvider_1.httpProvider.get(url);
            return response.data;
        });
    }
}
exports.AnnouncementServiceLive = AnnouncementServiceLive;
//# sourceMappingURL=AnnouncementServiceLive.js.map